import { CenteredContainer } from '../../styled/CenteredContainer';
import Wordcloud from '../Wordcloud/Wordcloud';

const WordcloudView = ({
  gameId,
  roundId,
  isAuthenticated,
  uniqueId,
  refetchData,
}: {
  gameId: string;
  roundId: string;
  isAuthenticated: boolean;
  uniqueId?: string;
  refetchData?: boolean;
}) => {
  return (
    <CenteredContainer
      style={{
        width: '100%',
        height: '100%',
        maxHeight: '100vh',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Wordcloud
        roundId={roundId}
        gameId={gameId}
        isAuthenticated={isAuthenticated}
        uniqueId={uniqueId}
        refetchData={refetchData}
      />
    </CenteredContainer>
  );
};

export default WordcloudView;
